import { publicAsset } from '../lib/assets';
import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { createStoresBlock } from '../ui/store-badges';

export function renderHero(target: HTMLElement): void {
  const copy = createEl('div', { className: 'sv-hero__copy' }, [
    createEl('p', { className: 'sv-hero__eyebrow' }, ['Asistencia mecánica en ruta']),
    createEl('h1', { className: 'sv-hero__title', id: 'hero-title' }, [SITE.tagline]),
    createEl('p', { className: 'sv-hero__lead' }, [SITE.description]),
    createEl('div', { className: 'sv-btn-row sv-hero__actions' }, [
      createEl(
        'a',
        { className: 'sv-btn sv-btn--primary', href: '#funciones' },
        [SITE.heroCtaPrimary]
      ),
      createEl(
        'a',
        { className: 'sv-btn sv-btn--ghost', href: '#para-quien' },
        [SITE.heroCtaSecondary]
      ),
    ]),
    createStoresBlock({ variant: 'hero' }),
  ]);

  const visual = createEl('div', { className: 'sv-hero__visual' }, [
    createEl('img', {
      className: 'sv-hero__product-img',
      src: publicAsset('hero-product.png'),
      alt: SITE.heroProductAlt,
      width: '300',
      decoding: 'async',
      loading: 'eager',
    }),
  ]);

  const inner = createEl('div', { className: 'sv-inner sv-hero__grid' }, [copy, visual]);

  const section = createEl(
    'section',
    {
      className: 'sv-hero sv-section',
      id: 'inicio',
      'aria-labelledby': 'hero-title',
    },
    [inner]
  );
  target.appendChild(section);
}
